import { IAndroidWatchesImportantMessagesType, IAndroidWatchesInformationMessagesType } from 'types/watches';

export const androidWatchesImportantMessagesTypes: IAndroidWatchesImportantMessagesType[] = [
	{ id: 'Alcohol', name: 'Alcohol', disabled: false },
	{ id: 'CallWaiter', name: 'CallWaiter', disabled: false },
	{ id: 'Order', name: 'Order', disabled: false },
	{ id: 'OrderPaid', name: 'OrderPaid', disabled: false },
];

export const androidWatchesInformationMessagesTypes: IAndroidWatchesInformationMessagesType[] = [];
